import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-decim',
  templateUrl: './decim.component.html',
  styleUrls: ['./decim.component.scss']
})
export class DecimComponent {

  constructor() { }

}
